import { BusinessFrontPageHighlightType } from '@/models/businesses/business-front-page-highlight';
import { axiosService } from '..';

export default class UpdateBusinessFrontPageHighlightService {
    public async execute(businessId: number, input: UpdateBusinessFrontPageHighlightServiceInputDto): Promise<UpdateBusinessFrontPageHighlightServiceOutputDto> {
        const formData = new FormData();
        formData.append('uniqueIdentifier', input.uniqueIdentifier);
        if (input.title) {
            formData.append('title', input.title);
        }
        if (input.value) {
            formData.append('value', input.value.toString());
        }
        if (input.imageUrl) {
            formData.append('imageUrl', input.imageUrl);
        }
        if (input.image) {
            formData.append(input.image.name, input.image);
        }
        formData.append('type', input.type.toString());

        const response = await axiosService.instance.post(`businesses/organization/front-page/${businessId}/update-highlight`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

        return new UpdateBusinessFrontPageHighlightServiceOutputDto(
            response.data.uniqueIdentifier,
            response.data.title,
            response.data.value,
            response.data.imageUrl,
            response.data.type
        );
    }
}

export class UpdateBusinessFrontPageHighlightServiceInputDto {
    public uniqueIdentifier: string;
    public title: string | null;
    public value: number | null;
    public imageUrl: string | null;
    public image: File | null;
    public type: BusinessFrontPageHighlightType;

    constructor(uniqueIdentifier: string, title: string | null, value: number | null, imageUrl: string | null, image: File | null, type: BusinessFrontPageHighlightType) {
        this.uniqueIdentifier = uniqueIdentifier;
        this.title = title;
        this.value = value;
        this.imageUrl = imageUrl;
        this.image = image;
        this.type = type;
    }
}

export class UpdateBusinessFrontPageHighlightServiceOutputDto {
    private uniqueIdentifier: string;
    private title: string | null;
    private value: number | null;
    private imageUrl: string | null;
    private type: BusinessFrontPageHighlightType;

    constructor(uniqueIdentifier: string, title: string | null, value: number | null, imageUrl: string | null, type: BusinessFrontPageHighlightType) {
        this.uniqueIdentifier = uniqueIdentifier;
        this.title = title;
        this.value = value;
        this.imageUrl = imageUrl;
        this.type = type;
    }
}

export const updateBusinessFrontPageHighlightService = new UpdateBusinessFrontPageHighlightService();
